import { render, staticRenderFns } from "./Test1.vue?vue&type=template&id=4cc4d1a2&scoped=true&"
import script from "./Test1.vue?vue&type=script&lang=js&"
export * from "./Test1.vue?vue&type=script&lang=js&"
import style0 from "./Test1.vue?vue&type=style&index=0&id=4cc4d1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc4d1a2",
  null
  
)

export default component.exports